var styles = {"box":"CategoryCard_box_9x8fa_1","active":"CategoryCard_active_9x8fa_13","v2":"CategoryCard_v2_9x8fa_17","box__inner":"CategoryCard_box__inner_9x8fa_26","image-wrapper":"CategoryCard_image-wrapper_9x8fa_31","title":"CategoryCard_title_9x8fa_49"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
